import { BreadcrumbsWidget, TextLinkWidget } from '@tableau/widgets';
import React from 'react';
import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';

import { BreadcrumbInfo } from './BreadcrumbInfo';
import { BreadcrumbStyles } from './BreadcrumbStyles';

export namespace Breadcrumbs {
  export interface StateProps {
    items: ReadonlyArray<BreadcrumbInfo>;
    linkLastItem: boolean;
  }

  export interface OwnProps {
    trailingElements?: Array<React.ReactElement>;
  }
  export interface Props extends StateProps, OwnProps {}
}

export const breadcrumbsTestId = 'breadcrumb-list';

export function Breadcrumbs(props: Breadcrumbs.Props): React.ReactElement<Breadcrumbs.Props> {
  if (props.items.length <= 1 && !props.linkLastItem) {
    return null;
  }

  const breadcrumbs: JSX.Element[] = _.map(props.items, (item, index, items) => {
    if (index < items.length - 1 || props.linkLastItem) {
      return <TextLinkWidget key={index}
                className={BreadcrumbStyles.Breadcrumb}
                children={item.text}
                href={(index < items.length - 1 || props.linkLastItem) ? item.href : null}
                testId={item.testId}
                title={item.text}
              />;
    } else {
      return <span className={BreadcrumbStyles.Breadcrumb} title={item.text}>{item.text}</span>;
    }
  });

  return <BreadcrumbsWidget aria-label={Messages.breadcrumbAriaLabel()} testId={breadcrumbsTestId} trailingElements={props.trailingElements}>
    {breadcrumbs}
  </BreadcrumbsWidget>;
}
